import { render, staticRenderFns } from "./LastMasterclass.vue?vue&type=template&id=f3b7456c&scoped=true&"
import script from "./LastMasterclass.vue?vue&type=script&lang=js&"
export * from "./LastMasterclass.vue?vue&type=script&lang=js&"
import style0 from "./LastMasterclass.vue?vue&type=style&index=0&id=f3b7456c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3b7456c",
  null
  
)

export default component.exports